import {
  type LicenseAdditionalFeatureName,
  isAimLicenseValid,
  licenseAdditionalFeatureNames,
} from '@ipfabric/utils/license/licenseSchema';
import type { License } from 'components/GlobalState/GlobalStateModel';
import { AimTeaserPage } from 'pages/Inventory/Applications/AimTeaser/AimTeaserPage';
import type { ReactNode } from 'react';

export type LicenseFeatureAvailability = Record<
  LicenseAdditionalFeatureName,
  boolean
>;

type LicenseFeatureDefinition = {
  isAvailable: (license: License) => boolean;
  unlicensedContent: ReactNode;
};

export const licenseFeatureDefinitions = {
  aim: {
    isAvailable: (license) =>
      license.validTo !== null &&
      isAimLicenseValid({
        expiry: license.validTo,
        additionalFeatures: license.additionalFeatures,
      }),
    unlicensedContent: <AimTeaserPage />,
  },
} satisfies Record<LicenseAdditionalFeatureName, LicenseFeatureDefinition>;

export const getLicenseFeatureAvailability = (
  license: License,
): LicenseFeatureAvailability =>
  licenseAdditionalFeatureNames.reduce<LicenseFeatureAvailability>(
    (availability, feature) => {
      availability[feature] =
        license.state === 'VALID' &&
        licenseFeatureDefinitions[feature].isAvailable(license);
      return availability;
    },
    {} as LicenseFeatureAvailability,
  );
